// ListWrapper.js
import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';

import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles'
import InputWrapper from './InputWrapper'
import { setInputmultiLanguageValue, valMax } from 'utils'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const style = makeStyles(theme => ({
    textArea: {
      width: `100%`,
      height: `200px !important`,
      padding: theme.spacing(1.5),
      resize: `none`,
      border: `1px solid #7F8FA4`,
      borderRadius: 5,
      color: `black`,
      fontSize: theme.fontSize[1],
      '&:focus': {
        border: `1px solid #007BFF`,
        outline: `none !important`,
      },
    },
    valid: {
      borderRadius: 5,
      border: `1px solid #007BFF`,
    },
    error: {
      border: `1px solid ${theme.palette.error.main}`,
    },
    viewMode: {
      color: `black`,
      border: `none`,
      background: `transparent`,
      padding: theme.spacing(1.5, 0),
      '& > input': {
        background: `transparent`,
      },
    },
    textWarning: {
      color: `#FF5252`,
    },
    textRight: {
      display: `block`,
      textAlign: `right`,
    },
  }))

const ListWrapper = ({
    id,
    label,
    error,
    isRequired = false,
    onChange,
    onBlur,
    isValid,
    value,
    id: name,
    placeholder,
    disabled = false,
    align = `left`,
    md = 12,
    xs = 12,
    rows = 4,
    rowsMax = 10,
    multiLanguage = false,
    languageKey = ``,
    viewMode = false,
    showCounter = false,
    rules: { min = 0, max, useFormValue = false, required = false } = {},
    rules,
    maxMessage = `Se ha alcanzado el máximo de caracteres permitido`,
    useOnChangeInsteadOnBlur = false,
    useNameInsteadId = false,
    ...rest
  }) => {
  const [itemList, setItemList] = useState([]);
  const [newItem, setNewItem] = useState('');
  const classes = style()
  const [localValue, setLocalValue] = useState(multiLanguage ? value[languageKey] : value)
  const isMaxCounter = max && (localValue ? localValue.length : 0) >= max
  
  const handleAddItem = () => {
    if (newItem.trim() !== '') {
      let temp=[];
      temp=[...itemList];
      temp.push(newItem);
      setItemList(temp);
      
      setNewItem('');
      
      //console.log('así quedará',temp.join(';'));
      //handleNewValue(temp.join(';'),name);
      //console.log('el value que viene',value);
      
      handleNewValue(temp.join(';'),name);

 
    }
  };

 
  useEffect(() => {
    //const valores=value.split(';');
    //console.log(value.split(';'));
    if(!value[languageKey] || value[languageKey].trim() === ""){
      //console.log(error)
      setItemList([]);
    }else{
      setItemList(value[languageKey].split(';'));
      //console.log("el valor",value[languageKey]);
    }
    
  }, [value])
  
  


  function handleNewValue(nextValue, name) {
    const listenFunction = useOnChangeInsteadOnBlur ? onChange : onBlur
    return listenFunction({
      name: useNameInsteadId ? name : id,
      value: multiLanguage
        ? setInputmultiLanguageValue({
            languageKey,
            value: {
              current: value,
              next: nextValue,
            },
          })
        : nextValue,
      id,
      languageKey,
    })
  }

  const handleDeleteItem = index => {
    const updatedList = [...itemList];
    updatedList.splice(index, 1);
    setItemList(updatedList);
    handleNewValue(updatedList.join(';'),name);
  };

  return (
    <>
    <InputWrapper
      label={label}
      isRequired={isRequired || required}
      align={align}
      error={error}
      md={md}
      xs={xs}
      disabled={disabled}
      languageKey={languageKey}
      {...rest}
    >
      
        <TextField
          value={newItem}
          onChange={e => setNewItem(e.target.value)}
          placeholder="Nuevo elemento"
          InputProps={{
            endAdornment: (
              <AddIcon
                style={{ cursor: 'pointer' }}
                color="primary"
                title="Agregar elemento"
                onClick={handleAddItem}
              />
            ),
          }}
        />
      
    

    </InputWrapper>
      {/* Lista de elementos */}
      <div style={{ width: '100%' }} className='listados'>
        <List>
          {itemList.map((item, index) => (
            <ListItem key={index}>
              <ListItemText primary={item} />
              <Button onClick={() => handleDeleteItem(index)} color="danger">
                <DeleteIcon style={{ color: 'red' }} />
              </Button>
            </ListItem>
          ))}
        </List>

        {/* Mensaje si la lista está vacía */}
        {itemList.length === 0 && (
          <Typography variant="body1" color="textSecondary">
            La lista está vacía.
          </Typography>
        )}
      </div>
      
    </>
 
      
   
  );
};

export default ListWrapper;
